import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import DescriptionIcon from '@mui/icons-material/Description';
import { loginSchema } from '../schemes/RelatorioDeVendas';

export default function ModalRealatorioDeVendas({ open, onClose, onSearch, isLoading }) {

    const [formData, setFormData] = useState({
        operador: '',
        ativo: 'S',
        data_inicio: null,
        data_fim: null,
        incluir_produtos: 'N'
    });



    const [erroDataInicioMessage, seterroDataInicioMessage] = useState("");
    const [erroDataFimMessage, seterroDataFimMessage] = useState("");


    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleDateChange = (name, newValue) => {
        setFormData(prev => ({ ...prev, [name]: newValue }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Converta para string se estiver usando dayjs ou null
        let data_inicio = formData?.data_inicio ? dayjs(formData.data_inicio).format('YYYY-MM-DD') : '';
        let data_fim = formData?.data_fim ? dayjs(formData.data_fim).format('YYYY-MM-DD') : '';

        const result = loginSchema.safeParse({ data_inicio, data_fim });


        seterroDataInicioMessage('');
        seterroDataFimMessage('');

        if (!result.success) {
            const errors = result.error.format();

            if (errors.data_inicio?._errors?.length) {
                seterroDataInicioMessage(errors.data_inicio._errors[0]);
            }

            if (errors.data_fim?._errors?.length) {
                seterroDataFimMessage(errors.data_fim._errors[0]);
            }
            return;
        }

        onSearch({
            ...formData,
            data_inicio,
            data_fim,
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth sx={{
            '& .MuiDialog-container': {
                alignItems: 'flex-start', // faz o Dialog ficar mais para cima
            }
        }}>
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ width: '100%' }}
            >
                <DialogTitle>Gerar relatório de vendas</DialogTitle>
                <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                                <InputLabel>Data início</InputLabel>
                                <DatePicker
                                    slotProps={{
                                        textField: {
                                            helperText: erroDataInicioMessage != "" ? erroDataInicioMessage : "",
                                            error: erroDataInicioMessage !== "", // Ativa a borda vermelha
                                        },

                                    }}
                                    sx={{ width: '100%', backgroundColor: 'white' }}
                                    value={formData.data_inicio}
                                    onChange={(newValue) => handleDateChange('data_inicio', newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            required
                                            sx={{ height: '56px' }} // altura padrão do TextField
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                                <InputLabel>Data fim</InputLabel>
                                <DatePicker
                                    slotProps={{
                                        textField: {
                                            helperText: erroDataFimMessage != "" ? erroDataFimMessage : "",
                                            error: erroDataFimMessage !== "", // Ativa a borda vermelha
                                        },
                                    }}
                                    sx={{ width: '100%', backgroundColor: 'white' }}
                                    value={formData.data_fim}
                                    onChange={(newValue) => handleDateChange('data_fim', newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            required
                                            sx={{ height: '56px' }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                                <InputLabel>Incluir produtos</InputLabel>
                                <FormControl fullWidth sx={{ height: '56px' }}>
                                    <Select
                                        sx={{ height: '100%', backgroundColor: 'white' }}
                                        name="incluir_produtos"
                                        value={formData.incluir_produtos}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="S">Sim</MenuItem>
                                        <MenuItem value="N">Não</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                                <InputLabel>Operador</InputLabel>
                                <FormControl fullWidth sx={{ height: '56px' }}>
                                    <Select
                                        sx={{ height: '100%', backgroundColor: 'white' }}
                                        name="operador"
                                        value={formData.operador}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="cielo">Cielo</MenuItem>
                                        <MenuItem value="stone">Stone</MenuItem>
                                        <MenuItem value="getnet">GetNet</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </LocalizationProvider>
                </DialogContent>

                <DialogActions>
                    <Button
                        type="submit"
                        variant="outlined"
                        endIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <DescriptionIcon />}
                        disabled={isLoading}
                    >
                        Gerar relatório
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}

